module.exports = __webpack_public_path__ + "img/background-wechat.6b3ad8c0.jpg";